import { put } from 'redux-saga/effects';
import { initCustomSetDeviationStream, initGallectionStream, initBrowseStream, initPostStream, initGallectionDeviationStream, initTierStream, initTierDeviationStream, initCommissionStream } from '../actions';
import { MediaSourceType } from '../types';
export default function*({ payload }) {
    if (!payload) {
        return;
    }
    const { mediaSource, gallectionFolder, initialDeviationSet } = payload;
    if ([
        MediaSourceType.GALLERY,
        MediaSourceType.COLLECTION,
        MediaSourceType.PRIVATE_COLLECTION,
        MediaSourceType.STASH
    ].includes(mediaSource)) {
        // First we load the top level list of gallections. We need this even when viewing a specific folder,
        // to get the full list of folders where we can move/copy deviations to.
        yield put(initGallectionStream({}));
        // When MM is opened to view a folder directly, we load the folder's gallection stream to get the subfolders,
        // plus the deviation stream with all deviations in it.
        if (gallectionFolder) {
            yield put(initGallectionStream({
                folderId: gallectionFolder.folderId
            }));
            yield put(initGallectionDeviationStream());
        }
    } else if (mediaSource === MediaSourceType.BROWSE) {
        yield put(initBrowseStream());
    } else if ([
        MediaSourceType.POLL,
        MediaSourceType.STATUS,
        MediaSourceType.JOURNAL,
        MediaSourceType.POSTS
    ].includes(mediaSource)) {
        yield put(initPostStream(mediaSource));
    } else if (mediaSource === MediaSourceType.TIER) {
        yield put(initTierStream());
    } else if (mediaSource === MediaSourceType.COMMISSIONS) {
        yield put(initCommissionStream());
    } else if ([
        MediaSourceType.TIER_DEVIATIONS,
        MediaSourceType.TIER_POSTS
    ].includes(mediaSource)) {
        yield put(initTierDeviationStream());
    } else if (mediaSource === MediaSourceType.CUSTOM_SET && initialDeviationSet) {
        yield put(initCustomSetDeviationStream(initialDeviationSet));
    }
}

//# sourceMappingURL=initMediaPopup.js.map